'use client';
import { createContext } from 'react';

const EnvContext = createContext<any>(null);

export default EnvContext;
